import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { VariablesService } from 'src/app/shared/services';

@Component({
  imports: [RouterLink],
  selector: 'app-mini-footer',
  templateUrl: './mini-footer.component.html',
  styleUrls: ['./mini-footer.component.scss']
})
export class MiniFooterComponent {
  readonly vars = inject(VariablesService);
  currentYear = new Date().getFullYear();
}
